class Paginator {
    constructor(feedbacks) {
        this.feedbacks = feedbacks;
    }

    updateFeedbacks(feedbacks) {
        this.feedbacks = feedbacks;
    }

    getIndex($id) {
        return this.feedbacks.findIndex((element) => {
            return element.id === $id;
        })
    }

    current($id) {
        return this.feedbacks.find((element) => {
            return element.id === $id;
        })
    }

    next($id) {
        if (this.feedbacks.length === 1) {
            return null;
        }
        const index = this.getIndex($id);
        if (this.feedbacks[index + 1] !== undefined) {
            return this.feedbacks[index + 1];
        }

        return null;
    }

    previous($id) {
        if (this.feedbacks.length === 1) {
            return null;
        }

        const index = this.getIndex($id);
        if (this.feedbacks[index - 1] !== undefined) {
            return this.feedbacks[index - 1];
        }

        return null;
    }
}

export default Paginator;
